
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1404Dialog extends Serenity.EntityDialog<Report_1404Row, any> {
        protected getFormKey() { return Report_1404Form.formKey; }
        protected getIdProperty() { return Report_1404Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1404Row.localTextPrefix; }
        protected getNameProperty() { return Report_1404Row.nameProperty; }
        protected getService() { return Report_1404Service.baseUrl; }
        protected getDeletePermission() { return Report_1404Row.deletePermission; }
        protected getInsertPermission() { return Report_1404Row.insertPermission; }
        protected getUpdatePermission() { return Report_1404Row.updatePermission; }

        protected form = new Report_1404Form(this.idPrefix);

    }
}